import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 px-6 bg-gray-900 text-white border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About Section */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_young-tech-careers/artifacts/rfv9wrv7_original-B1BE815D-C806-43C2-B76A-E4E1916083E4.jpeg"
              alt="The 317 Foundation"
              className="h-16 w-auto object-contain mb-4 brightness-0 invert"
            />
            <p className="text-cyan-400 italic text-sm mb-3">
              "Bridging You to the Future You Deserve.."
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering youth with practical IT services skills and AI education through our innovative learn-and-earn model.
            </p>
          </div>

          {/* Contact Section */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-cyan-400">Contact Us</h3>
            <div className="space-y-3">
              <a href="tel:8003185922" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                <Phone size={16} />
                <span>(800) 318-5922</span>
              </a>
              <a href="mailto:info@the317foundation.org" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors text-sm">
                <Mail size={16} />
                <span>info@the317foundation.org</span>
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-cyan-400">Quick Links</h3>
            <div className="space-y-2">
              <a href="#about" className="block text-gray-400 hover:text-cyan-400 transition-colors text-sm">About Us</a>
              <a href="#courses" className="block text-gray-400 hover:text-cyan-400 transition-colors text-sm">Courses</a>
              <a href="#contact" className="block text-gray-400 hover:text-cyan-400 transition-colors text-sm">Contact</a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} The 317 Foundation. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs mt-2">
            317 Learners, 317 Futures
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;